import * as _ from "lodash";
import {Roles} from '../../common/enums/Roles';

class UserRolesTableController implements angular.IOnInit {
  public userRoles: string[];

  public roles: string[] = [Roles.FinancialAnalyst, Roles.SystemAdministrator, Roles.PortfolioTeam, Roles.TradingAdministrator, Roles.SeniorManagement,
     Roles.Client, Roles.Accountant, Roles.SeniorAccountant, Roles.UserAdministrator,Roles.ViewOnly, Roles.Broker, Roles.Bank, Roles.ConfidentDirector,
    Roles.Partners,
    Roles.Supplier,
    Roles.Prospect,
    Roles.Compliance];

  constructor(){}

  $onInit(): void {
  }

  public formatRole(role: string) {
    return role.split('_').map(r => _.capitalize(r)).join(' ');
  }

  public removeRole(role: string) {
    this.userRoles = this.userRoles.filter(r => r !== role);
  }
}

export const userRolesTable: angular.IComponentOptions = {
  controller: UserRolesTableController,
  template: require('./userRolesTable.component.html'),
  bindings: {
    userRoles: '='
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/userRolesTable.component.ts